import React from "react";
import BulkPaymentHero from "./BulkPaymentHero";
import WorkSmarter from "./WorkSmarter";
import JoinNetwork from "./JoinNetwork";
import WorkPayment from "./WorkPayment";
import svg98 from "../../../../assets/svg/svg98.svg";
import svg99 from "../../../../assets/svg/svg99.svg";
import svg100 from "../../../../assets/svg/svg100.svg";
import svg102 from "../../../../assets/svg/svg102.svg";
import svg103 from "../../../../assets/svg/svg103.svg";
import svg104 from "../../../../assets/svg/svg104.svg";
import svg105 from "../../../../assets/svg/svg105.svg";
import svg108 from "../../../../assets/svg/svg108.svg";
import svg109 from "../../../../assets/svg/svg109.svg";
import svg111 from "../../../../assets/svg/svg111.svg";
import svg112 from "../../../../assets/svg/svg112.svg";
import svg101 from "../../../../assets/svg/svg101.svg";

const itemsHero = [
  {
    title: "Instant payments",
    svg: svg98,
    desc: "Send payments directly to bank accounts or mobile wallets like M-Pesa and Airtel Money in seconds.",
  },
  {
    title: "Bulk upload",
    svg: svg99,
    desc: "Upload bulk files or integrate via API. Simple, fast, and transparent.",
  },
  {
    title: "Real-time tracking",
    svg: svg100,
    desc: "See every transaction’s status live with instant receipts, reports, and full visibility.",
  },
];
const titleHero = " Simplify Mass Payouts in Seconds";
const subtitleHero =
  "  Disburse funds to hundreds of employees, suppliers, or agents instantly from one secure dashboard.";

const itemsSmarter = [
  {
    title: "Reduce manual work & payment errors",
    svg: svg102,
    desc: "Automate repetitive payout processes and eliminate human mistakes with smart validation tools.",
  },
  {
    title: "Save Time with Batch Processing",
    svg: svg103,
    desc: "Disburse hundreds of payments at once, no more handling individual transfers or approvals.",
  },
  {
    title: "Multi-Currency Transactions",
    svg: svg104,
    desc: "Handle payments in KES, USD, or other supported currencies seamlessly from one dashboard.",
  },
  {
    title: "Automated Payment Reports",
    svg: svg105,
    desc: "Generate real-time reports and digital records instantly, making audits faster and stress-free.",
  },
];

const titleSmarter = "Work Smarter. Pay Faster. Stay in Control.";
const subtitleSmarter =
  "Automate bulk disbursements, save time, and eliminate errors, full transparency and instant tracking..";

const itemsWorkPayment = [
  {
    svg: svg108,
    title: "Prepare your list",
    desc: "Upload a CSV or Excel file with recipient details and amounts.",
  },
  {
    svg: svg109,
    title: "Review & Approve",
    desc: "Confirm entries, set authorization levels, and approve payouts.",
  },
  {
    svg: svg111,
    title: "Disburse Instantly",
    desc: "Funds are sent through banks or mobile channels in seconds.",
  },
  {
    svg: svg112,
    title: "Track & Reconcile",
    desc: "View real-time statuses, download reports, and get instant receipts.",
  },
];

const titleWorkPayment = "How Bulk Payments Work";
const subtitleWorkPayment =
  "Mobile banking differs from mobile payments, which involves the use of a mobile device";
const title = "Join the growing network of organizations using Ndovu Pay";
const subtitle = "Experience the future of business payments with Ndovu Pay";
function BulkPayment({ setActive }) {
  return (
    <div id="bulk-payment">
      <BulkPaymentHero
        items={itemsHero}
        title={titleHero}
        subtitle={subtitleHero}
        svg101={svg101}
      />
      <WorkSmarter
        items={itemsSmarter}
        title={titleSmarter}
        subtitle={subtitleSmarter}
      />
      <WorkPayment
        items={itemsWorkPayment}
        title={titleWorkPayment}
        subtitle={subtitleWorkPayment}
      />
      <JoinNetwork title={title} subtitle={subtitle} setActive={setActive} />
    </div>
  );
}

export default BulkPayment;
